import React, { Fragment } from "react";
import { Navigate, Outlet, Route } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import {
  getPracticeSpecialty,
  shouldSkipSpecialtySelect,
} from "../utils/helpers/practiceSpecialty";

// const ProtectedRoute = ({ component: Component, isAuthenticated, ...rest }) => (
//   <Fragment>
//     {isAuthenticated ? <Component {...rest} /> : <Navigate to="/signin" />}
//   </Fragment>
// );

const ProtectedRoute = ({ isAuthenticated, children, layout = AppLayout }) => {
  if (!isAuthenticated && isAuthenticated !== "") {
    return <Navigate to="/signin" />;
  }

  if (
    isAuthenticated &&
    !getPracticeSpecialty() &&
    !shouldSkipSpecialtySelect()
  ) {
    return <Navigate to="/select-specialty" replace />;
  }

  const Wrapper = layout || AppLayout;

  return children ? children : <Wrapper />;
};

export default ProtectedRoute;
